import { defineStyleConfig } from '@chakra-ui/react';

export const headingTheme = defineStyleConfig({
  sizes: {
    headingHero: {
      fontSize: ['24px', '36px'],
      fontWeight: 600,
      lineHeight: ['28px', '40px'],
      letterSpacing: 0,
    },
    headingPrimary: {
      fontSize: ['20px', '24px'],
      fontWeight: 600,
      lineHeight: ['24px', '32px'],
      letterSpacing: 0,
    },
    headingSecondary: {
      fontSize: ['18px', '20px'],
      fontWeight: 600,
      lineHeight: ['20px', '28px'],
      letterSpacing: 0,
    },
  },
});
